import creditDay from '@/api/default-credit-day'
import feeGroup from '@/api/fee-group'
import feeType from '@/api/fee-type'
import invoice from '@/api/invoice'
import preInvoice from '@/api/pre-invoice'
import promotion from '@/api/promotion'
import classOperation from '@/api/class-operation'
import academicYear from '@/api/academic-year'
import termSemester from '@/api/term-semester'
import vehicle from '@/api/vehicle-profile'
import { isEmpty, join } from 'lodash'
import moment from 'moment'

import { baseMutations, baseState } from '@/store/mixins'

const currentInvoiceDate = () => moment().format('DD-MM-YYYY')

const invoiceFilterParams = state => ({
  search: state.search,
  date_from: state.date_from || undefined,
  date_to: state.date_to || undefined,
  all_branch: Array.isArray(state.branch_id)
    ? state.branch_id.length
      ? undefined
      : true
    : true,
  branch_id: state.branch_id,
  filter_by_fee_type: Array.isArray(state.filter_by_fee_type)
    ? state.filter_by_fee_type
    : undefined,
  filter: {
    is_new_student: state.is_new_student,
    is_deleted: state.is_deleted | 0,
    acp_id: join(state.acp_id, ','),
    acps_id: join(state.acps_id, ','),
    ac_status_id: state.ac_status_id.length
      ? join(state.ac_status_id, ',')
      : undefined,
    ac_year_id: join(state.ac_year_id, ','),
    ac_term_id: join(state.ac_term_id, ','),
    created_by: join(state.created_by, ','),
    class_id: join(state.class_id, ',')
  }
})

export const state = {
  ...baseState,
  defaultCreditDay: 0,
  room_type_id: null,
  branch_id: null,
  showData: {},
  feeSetups: [],
  mainPrograms: [],
  acp_id: [],
  acps_id: [],
  ac_status_id: [],
  ac_year_id: [],
  ac_term_id: [],
  promotionRate: [],
  date_from: currentInvoiceDate(),
  date_to: currentInvoiceDate(),
  is_deleted: 0,
  created_by: [],
  is_new_student: undefined,
  filter_by_fee_type: undefined,
  class_id: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SHOW_DATA(state, data) {
    state.showData = data
  },
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_CURRENT_DATE_FILTER(state) {
    const currentDate = currentInvoiceDate()

    state.date_from = currentDate
    state.date_to = currentDate
  },
  SET_DEFAULT_CREDIT_DAY(state, numberDay) {
    state.defaultCreditDay = numberDay
  },
  SET_ROOM_TYPE_ID(state, id) {
    state.room_type_id = id
  },
  SET_MAIN_PROGRAM(state, data) {
    state.mainPrograms = data
  },
  SET_APC_ID(state, data) {
    state.acp_id = data
  },
  SET_APCS_ID(state, data) {
    state.acps_id = data
  },
  SET_AC_STATUS_ID(state, data) {
    state.ac_status_id = data
  },
  SET_AC_YEAR_ID(state, data) {
    state.ac_year_id = data
  },
  SET_AC_TERM_ID(state, data) {
    state.ac_term_id = data
  },
  SET_IS_DELETE(state, data) {
    state.is_deleted = data
  },
  SET_PROMOTION_VALUE(state, promotionRate) {
    if (promotionRate.length > 0) {
      state.promotionRate = promotionRate[0]
    }
  },
  SET_IS_NEW_STUDENT(state, data) {
    state.is_new_student = data
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_CREATED_BY(state, data) {
    state.created_by = data
  },
  SET_FILTER_BY_FEE_TYPE(state, data) {
    state.filter_by_fee_type = data
  },
  SET_CLASS_ID(state, data) {
    state.class_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage
      },
      invoiceFilterParams(context.state),
      attrubutes
    )
    return invoice.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  exportExcel(context) {
    return invoice.exportExcel(invoiceFilterParams(context.state))
  },
  async find(context, id) {
    if (isEmpty(context.state.showData)) {
      let response = await invoice.find(id)
      context.commit('SET_SHOW_DATA', response.data)
    }
  },
  store(context, data) {
    return invoice.store(data)
  },
  destroy(context, { id, data }) {
    return invoice.destroy(id, data)
  },
  getFeeType(context, attrubutes = {}) {
    return feeType.get({
      params: attrubutes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getStudent(context, attrubutes = {}) {
    return invoice.getStudent({
      params: attrubutes
    })
  },
  getPreInvoice(context, attrubutes = {}) {
    return preInvoice.get({
      params: attrubutes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getFeeGroup(context, grade_id) {
    return feeGroup.listQuery(grade_id)
  },
  getLatestInvoice(context, studentId) {
    return invoice.latestInvoiceStudent(studentId)
  },
  async getDefaultCreditDay(context, attrubutes = {}) {
    if (!context.state.defaultCreditDay > 0) {
      let response = await creditDay.get({
        params: attrubutes,
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      if (response.data.length > 0) {
        context.commit('SET_DEFAULT_CREDIT_DAY', response.data[0].credit_day)
      }
    }
  },
  getSubscriptionService(context, data) {
    return invoice.studentSubscript(data)
  },
  getFeeSetupDetail(context, data) {
    return invoice.getFeeSetupWithDetail(data)
  },
  feeGroupDetail(context, data) {
    return invoice.feeGroupDetail(data)
  },
  registerVehicel(context, studentId) {
    return invoice.checkStudentRegisterVehicel(studentId)
  },
  getVehicleOperation(context, attrubutes = {}) {
    return vehicle.get({
      params: attrubutes,
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  previewPdf(context, id) {
    return invoice.printPDF(id)
  },
  getPromotion(context, { condition }) {
    return promotion
      .get({
        params: {
          fields: {
            academic_program_sub_promotions:
              'promotion_rate,promotion_expiry_date'
          },
          filter: {
            acps_id: condition.acps_id,
            ac_term_id: condition.ac_term_id,
            where_expired_date: moment().format('YYYY-MM-DD')
          },
          page: -1
        },
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      .then(response => {
        context.commit('SET_PROMOTION_VALUE', response.data)
        return Promise.resolve(response.data)
      })
      .catch(error => {
        Promise.reject(error.data)
      })
  },
  getMainProgram(context) {
    return invoice
      .getMainProgram({
        params: {
          fields: {
            academic_program_mains: 'acp_id,acp_name_foreign,company_id'
          },
          page: -1
        },
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      .then(response => {
        context.commit('SET_MAIN_PROGRAM', response.data)
        return Promise.resolve(response.data)
      })
      .catch(error => {
        Promise.reject(error.data)
      })
  },
  fetchClassOperation(context, attributes = {}) {
    return classOperation.get({
      params: {
        branch_id: attributes.branch_id,
        fields: {
          academic_classes:
            'class_id,class_name,acp_id,acps_id,ac_year_id,ac_term_id,ac_status_id,branch_id'
        },
        filter: {
          acp_id: Array.isArray(attributes.acp_id)
            ? join(attributes.acp_id, ',')
            : attributes.acp_id,
          acps_id: Array.isArray(attributes.acps_id)
            ? join(attributes.acps_id, ',')
            : attributes.acps_id,
          ac_year_id: Array.isArray(attributes.ac_year_id)
            ? join(attributes.ac_year_id, ',')
            : attributes.ac_year_id,
          ac_term_id: Array.isArray(attributes.ac_term_id)
            ? join(attributes.ac_term_id, ',')
            : attributes.ac_term_id,
          ac_status_id: Array.isArray(attributes.ac_status_id)
            ? attributes.ac_status_id.length
              ? join(attributes.ac_status_id, ',')
              : undefined
            : attributes.ac_status_id,
          branch_id: Array.isArray(attributes.branch_id)
            ? join(attributes.branch_id, ',')
            : attributes.branch_id
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  fetchAcademicYears(context, attributes = {}) {
    return academicYear.get({
      params: {
        include: 'branch',
        fields: {
          academic_years: 'ac_year_id,ac_year,ac_status_id,branch_id'
        },
        filter: {
          branch_id: Array.isArray(attributes.branch_id)
            ? attributes.branch_id.length
              ? join(attributes.branch_id, ',')
              : undefined
            : attributes.branch_id,
          ac_status_id: Array.isArray(attributes.ac_status_id)
            ? attributes.ac_status_id.length
              ? join(attributes.ac_status_id, ',')
              : undefined
            : attributes.ac_status_id
        },
        all_branch: attributes.all_branch,
        branch_id: attributes.branch_id,
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  fetchAcademicTerms(context, attributes = {}) {
    return termSemester.get({
      params: {
        include: 'branch',
        fields: {
          academic_terms:
            'ac_term_id,term_name,ac_status_id,term_order,branch_id,ac_year_id,acps_id'
        },
        filter: {
          branch_id: Array.isArray(attributes.branch_id)
            ? join(attributes.branch_id, ',')
            : attributes.branch_id,
          ac_year_id: Array.isArray(attributes.ac_year_id)
            ? join(attributes.ac_year_id, ',')
            : attributes.ac_year_id,
          acps_id: Array.isArray(attributes.acps_id)
            ? join(attributes.acps_id, ',')
            : attributes.acps_id,
          ac_status_id: Array.isArray(attributes.ac_status_id)
            ? attributes.ac_status_id.length
              ? join(attributes.ac_status_id, ',')
              : undefined
            : attributes.ac_status_id
        },
        branch_id: attributes.branch_id,
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  fetchSubProgram(context, attributes = {}) {
    return invoice.getSubProgram({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          filter: {
            acp_id: attributes.acp_id
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  eligable(context, data) {
    return invoice.eligable(data)
  },
  createNewStudent(context, data) {
    return invoice.createNewStudent(data)
  },
  bankStudent(context, studentId) {
    return invoice.bankStudent(studentId)
  },
  getClassId(context, payload) {
    return invoice.getClassId(payload)
  },
  checkIsDuplicateFeeType(context, data) {
    return invoice.checkIsDuplicateFeeType(data)
  },
  getFormViewModel(context, Options = {}) {
    return invoice.formViewModel({
      params: Options
    })
  },
  getExchangeRate(context, data) {
    return invoice.exchangeRate(data)
  },
  updateOldNew(context, {id, data}) {
    return invoice.updateOldNew(id, data)
  }
}
